import { StatusQuery } from '@1bill-app/services/status/status.query';
import { Job, JobState } from '@1bill-app/services/status/types';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-bill-processing-block',
  templateUrl: './bill-processing-block.component.html',
  styleUrls: ['./bill-processing-block.component.scss'],
})
export class BillProcessingBlockComponent implements OnInit {
  @ViewChild('billProcessingRef', { read: ElementRef }) billProcessingRef: ElementRef;
  public firstBillInProgress$ = this.statusQuery.firstBillInProgress$;
  public latestJob$ = this.statusQuery.latestJob$;
  public isJobOnProgress$ = this.statusQuery.isJobOnProgress$;
  constructor(private statusQuery: StatusQuery) { }

  ngOnInit() {}
  isShowStaffActionMsg(latestJob: Job) {
    return (
      [JobState.SUCCESS, JobState.MODIFIED, JobState.DUPLICATE].indexOf(latestJob?.state) ===
      -1
    );
  }
  getBillProcessingCardRef() {
    return this.billProcessingRef && this.billProcessingRef.nativeElement as HTMLElement
  }
}
